import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isPublicSeoPath } from '../../seo/publicPages';
import { getPageTitleFromPath } from '../../utils/pageTitles';

/**
 * Sets document.title from the current route. Mount once inside BrowserRouter.
 * Public marketing/auth pages are owned by SeoHead. Pages may still override
 * the title (e.g. project name) after data loads.
 */
export default function DocumentTitleSync() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (isPublicSeoPath(pathname)) return;
    document.title = getPageTitleFromPath(pathname);
  }, [pathname]);

  return null;
}
